import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function DailyBetBackPromo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const bonusType = (brandId == 37 || brandId == 39 || brandId == 40) ? "CashBack" : "BetBack";
    const totalCashbackAmount = (brandId == 61) ? "$5" : isPK ? "PKR 150" : "₹50";
    const applicableExchangeType = isPK ? "PSL" : "IPL";

    function getDomain(brandId: any) {
        if ([31, 32, 61, 35, 36].includes(brandId)) return "Yolo247";
        if ([37, 39, 40].includes(brandId)) return "Fomo7";
        if ([46, 47, 49].includes(brandId)) return "Fun88";
        return "Iw247";
    }
    const domainName = getDomain(brandId);

    return (
        <>
            <InformationWrapper>
                <p className='top-para'>Play on Exchange with extra confidence on {domainName}. If your first bet of the day loses,<br />receive a 100% {bonusType} bonus and continue playing with reduced risk every day.</p>
                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconOne}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Place a cash bet on Cricket Matches on Exchange.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconTwo}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>If your first bet of the day loses.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconThree}`}
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Receive a 100% daily {bonusType} bonus the next day.</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>Valid from 01 March 2026 to 31 May 2026.</li>
                        <li>Applicable on Exchange bets only for: {applicableExchangeType}.</li>
                        <li>Only the first losing bet of the day is eligible.</li>
                        <li>100% {bonusType} up to {totalCashbackAmount}.</li>
                        <li>Maximum benefit per player per day: {totalCashbackAmount}.</li>
                        <li>{bonusType} is credited as a non-withdrawable bonus.</li>
                        <li>Bonus wagering requirements apply.</li>
                        <li>{domainName} reserves the right to modify, suspend, or cancel the promotion without prior notice.</li>
                        <li>General {domainName} terms & conditions apply.</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(DailyBetBackPromo));

const InformationWrapper = styled.div`
    width: 98%;
    padding: 4rem 0;
    height: auto;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.DailyBetBackBonusBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    gap: 3rem;

    & .top-para {
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const MainTitle = styled.h4`
    color: #FFDE00;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    margin: 0;
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 70%;
    height: auto;
    gap: 2rem;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;

const KeyDetailsSecBox = styled.div`
    width: 28%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 2rem 1.5rem;
    gap: 10px;
    border-radius: 14px;
    border: 0.5px solid rgba(255, 255, 255, 0.50);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(12.5px);

    .lazy-load-image-background {
        text-align: center;
        width: 61px;
        height: 61px;
    }

    img {
        width: 100%;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    border-radius: 14px;
    padding: 1rem;
    gap: 2rem;
    
    ul {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin: 0;

        li {
            color: #FFF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            text-align: justify;
            text-transform: capitalize;
        }
    }
`;